import { z } from "zod";

export const ENGAGEMENT_COUNT_KEY = "posthog:nps_engagement_count";
export const ELIGIBLE_KEY = "posthog:nps_eligible";
export const VIEWED_JOBS_KEY = "posthog:nps_viewed_job_ids";
export const JOB_THRESHOLD_REACHED_KEY = "posthog:nps_job_threshold_reached";

export const ENGAGEMENT_THRESHOLD = 2;
export const JOB_VIEW_THRESHOLD = 5;

const countSchema = z
  .string()
  .transform(Number)
  .pipe(z.number().min(0).catch(0));

export type StorageService = {
  get: (key: string) => string | null;
  set: (key: string, value: string) => void;
};
export type SetPersonFn = (props: Record<string, unknown>) => void;

export const createNpsEligibilityEngine = (
  storage: StorageService,
  setPersonFn: SetPersonFn,
) => {
  const isEligible = (): boolean => {
    return storage.get(ELIGIBLE_KEY) === "true";
  };

  const markEligible = (): void => {
    if (isEligible()) return;

    storage.set(ELIGIBLE_KEY, "true");
    setPersonFn({ discover_nps_eligible: true });
  };

  const registerEngagement = (): void => {
    if (isEligible()) return;

    const count = countSchema.parse(storage.get(ENGAGEMENT_COUNT_KEY) ?? "0");
    const newCount = count + 1;

    storage.set(ENGAGEMENT_COUNT_KEY, String(newCount));

    if (newCount >= ENGAGEMENT_THRESHOLD) {
      markEligible();
    }
  };

  return {
    isEligible,
    markEligible,
    registerEngagement,
  };
};
